(function () {
  'use strict';

  var STORAGE_KEY = 'ap_ems_country';

  function getCurrency() {
    if (window.Shopify && Shopify.currency) {
      return {
        code: Shopify.currency.active || 'JPY',
        rate: Number(Shopify.currency.rate) || 1,
      };
    }
    return { code: 'JPY', rate: 1 };
  }

  function formatMoney(amountJpy, currency) {
    var amount = amountJpy * currency.rate;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency.code,
        currencyDisplay: 'symbol',
      }).format(amount);
    } catch (e) {
      return currency.code + ' ' + amount.toFixed(2);
    }
  }

  function normalizeRatesData(data) {
    if (!data) return null;
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {
        return null;
      }
    }
    return data && data.zones ? data : null;
  }

  function findZone(ratesData, countryCode) {
    if (!ratesData || !ratesData.zones || !countryCode) return null;
    var code = String(countryCode).toUpperCase();
    for (var i = 0; i < ratesData.zones.length; i++) {
      var zone = ratesData.zones[i];
      if (zone.countries && zone.countries.indexOf(code) !== -1) {
        return zone;
      }
    }
    return null;
  }

  function findPriceJpy(zone, weightG) {
    if (!zone || !zone.rates || !zone.rates.length) return null;
    var weight = Number(weightG) || 0;
    for (var i = 0; i < zone.rates.length; i++) {
      var row = zone.rates[i];
      if (weight <= row.max_weight_g) {
        return row.price_jpy;
      }
    }
    return null;
  }

  function isExcluded(ratesData, countryCode) {
    var excluded = (ratesData && ratesData.excluded_destination_countries) || [];
    return excluded.indexOf(String(countryCode).toUpperCase()) !== -1;
  }

  function sanitizeWeightGrams(weightG, ratesData) {
    var weight = Number(weightG) || 0;
    var max = (ratesData && Number(ratesData.max_weight_g)) || 30000;
    // Admin often stores 250 + unit kg (meant 250g) → 250000g.
    // Only auto-correct absurdly high values (>=100kg).
    if (weight >= 100000) {
      var candidate = weight / 1000;
      if (candidate > 0 && candidate <= max) {
        return candidate;
      }
    }
    return weight;
  }

  function estimate(ratesData, countryCode, weightG) {
    var currency = getCurrency();
    if (isExcluded(ratesData, countryCode)) {
      return { ok: false, reason: 'excluded', currency: currency };
    }
    var zone = findZone(ratesData, countryCode);
    if (!zone) {
      return { ok: false, reason: 'no_zone', currency: currency };
    }
    var mailer = Number(ratesData.mailer_grams) || 0;
    var productWeight = sanitizeWeightGrams(weightG, ratesData);
    var shippingWeight = productWeight + mailer;
    var priceJpy = findPriceJpy(zone, shippingWeight);
    if (priceJpy == null) {
      return {
        ok: false,
        reason: 'over_weight',
        currency: currency,
        zone: zone,
        shippingWeight: shippingWeight,
      };
    }
    return {
      ok: true,
      currency: currency,
      zone: zone,
      shippingWeight: shippingWeight,
      priceJpy: priceJpy,
      formatted: formatMoney(priceJpy, currency),
    };
  }

  function readJson(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function readRates(root) {
    return normalizeRatesData(readJson(root.querySelector('[data-ems-rates]')));
  }

  function getQuantityNear(root) {
    var form =
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('product-form form') ||
      document.getElementById('product-form');
    var qtyInput =
      (form && form.querySelector('[name="quantity"]')) ||
      document.querySelector('quantity-input .quantity__input') ||
      document.querySelector('[name="quantity"]');
    if (!qtyInput) return 1;
    var qty = parseInt(qtyInput.value, 10);
    return qty > 0 ? qty : 1;
  }

  function getSelectedVariantId() {
    var input =
      document.querySelector('product-form [name="id"]') ||
      document.querySelector('form[action*="/cart/add"] [name="id"]') ||
      document.querySelector('.product-variant-id');
    return input ? String(input.value) : null;
  }

  function getWeightGrams(root, ratesData) {
    var mode = root.getAttribute('data-ems-mode') || 'product';
    if (mode === 'cart') {
      return sanitizeWeightGrams(Number(root.getAttribute('data-ems-weight-g')) || 0, ratesData);
    }

    var map = readJson(root.querySelector('[data-ems-variant-weights]')) || {};
    var variantId = getSelectedVariantId();
    var unitWeight =
      (variantId && map[variantId] != null
        ? Number(map[variantId])
        : Number(root.getAttribute('data-ems-weight-g'))) || 0;
    unitWeight = sanitizeWeightGrams(unitWeight, ratesData);
    return unitWeight * getQuantityNear(root);
  }

  function restoreCountry(select, root) {
    var saved = null;
    try {
      saved = sessionStorage.getItem(STORAGE_KEY);
    } catch (e) {}
    var preferred = saved || root.getAttribute('data-ems-visitor-country');
    if (!preferred) return;
    var option = select.querySelector('option[value="' + preferred + '"]');
    if (option) select.value = preferred;
  }

  function getJaRegionName(code) {
    if (typeof Intl === 'undefined' || typeof Intl.DisplayNames !== 'function') return code;
    try {
      return new Intl.DisplayNames(['ja'], { type: 'region' }).of(String(code).toUpperCase()) || code;
    } catch (e) {
      return code;
    }
  }

  function syncCountryLabel(ui) {
    if (!ui) return;
    var select = ui.querySelector('[data-ems-country]');
    var label = ui.querySelector('[data-ems-country-label]');
    var menu = ui.querySelector('[data-ems-country-menu]');
    if (!select || !label || !menu) return;
    var selected = menu.querySelector('.ap-ems-country__option[data-value="' + select.value + '"]');
    if (selected) {
      label.textContent = selected.textContent.replace(/\s+/g, ' ').trim();
    }
  }

  function setCountryValue(ui, code, opts) {
    opts = opts || {};
    var select = ui.querySelector('[data-ems-country]');
    var menu = ui.querySelector('[data-ems-country-menu]');
    if (!select || !menu) return;
    var value = String(code || '').toUpperCase();
    if (!value) return;

    select.value = value;
    Array.prototype.forEach.call(menu.querySelectorAll('.ap-ems-country__option'), function (item) {
      var on = item.getAttribute('data-value') === value;
      item.classList.toggle('is-selected', on);
      item.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    syncCountryLabel(ui);

    if (!opts.silent) {
      try {
        sessionStorage.setItem(STORAGE_KEY, value);
      } catch (e) {}
      var root = ui.closest('[data-ems-estimator]');
      if (root) render(root);
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function closeCountryMenu(ui) {
    var button = ui.querySelector('[data-ems-country-button]');
    var menu = ui.querySelector('[data-ems-country-menu]');
    if (!menu) return;
    menu.hidden = true;
    if (button) button.setAttribute('aria-expanded', 'false');
  }

  function openCountryMenu(ui) {
    var button = ui.querySelector('[data-ems-country-button]');
    var menu = ui.querySelector('[data-ems-country-menu]');
    if (!menu) return;
    // Re-sync label after GTranslate may have rewritten option spans
    syncCountryLabel(ui);
    menu.hidden = false;
    if (button) button.setAttribute('aria-expanded', 'true');
  }

  /**
   * Custom country list (not <select>/<option>) so GTranslate can translate JP source names.
   */
  function bindCountryUi(root) {
    var ui = root.querySelector('[data-ems-country-ui]');
    if (!ui || ui.dataset.emsCountryUiBound === 'true') return;
    ui.dataset.emsCountryUiBound = 'true';

    var select = ui.querySelector('[data-ems-country]');
    var button = ui.querySelector('[data-ems-country-button]');
    var menu = ui.querySelector('[data-ems-country-menu]');
    if (!select || !button || !menu) return;

    // Fill missing names (ISO-only) with Japanese for GTranslate source language
    Array.prototype.forEach.call(menu.querySelectorAll('[data-ems-fill-ja-name]'), function (item) {
      var code = item.getAttribute('data-value');
      var span = item.querySelector('span');
      if (span && code) span.textContent = getJaRegionName(code);
    });

    // Sort by current visible label (Japanese)
    var items = Array.prototype.slice.call(menu.querySelectorAll('.ap-ems-country__option'));
    items.sort(function (a, b) {
      return String(a.textContent || '').localeCompare(String(b.textContent || ''), 'ja');
    });
    items.forEach(function (item) {
      menu.appendChild(item);
    });

    restoreCountry(select, root);
    setCountryValue(ui, select.value, { silent: true });
    syncCountryLabel(ui);

    button.addEventListener('click', function (event) {
      event.preventDefault();
      if (menu.hidden) openCountryMenu(ui);
      else closeCountryMenu(ui);
    });

    menu.addEventListener('click', function (event) {
      var option = event.target.closest('.ap-ems-country__option');
      if (!option || !menu.contains(option)) return;
      setCountryValue(ui, option.getAttribute('data-value'));
      closeCountryMenu(ui);
    });

    document.addEventListener('click', function (event) {
      if (!ui.contains(event.target)) closeCountryMenu(ui);
    });

    // After language apps rewrite DOM, refresh the closed button label
    if (typeof MutationObserver === 'function') {
      var observer = new MutationObserver(function () {
        if (menu.hidden) syncCountryLabel(ui);
      });
      observer.observe(menu, { subtree: true, characterData: true, childList: true });
    }
  }

  function render(root) {
    var ratesData = readRates(root);
    var select = root.querySelector('[data-ems-country]');
    var priceEl = root.querySelector('[data-ems-price]');
    var noteEl = root.querySelector('[data-ems-note]');
    if (!ratesData || !select || !priceEl) return;

    var country = select.value;
    var weightG = getWeightGrams(root, ratesData);
    var result = estimate(ratesData, country, weightG);

    root.classList.remove('ap-ems-estimator--error');

    // Keep money out of translators
    priceEl.classList.add('notranslate');
    priceEl.setAttribute('translate', 'no');

    if (result.ok) {
      priceEl.textContent = result.formatted;
      priceEl.hidden = false;
      if (noteEl) {
        noteEl.textContent =
          'Estimated EMS for this order weight (includes mailer). Final shipping is calculated at checkout. Duties/taxes may apply.';
      }
      return;
    }

    priceEl.hidden = true;
    root.classList.add('ap-ems-estimator--error');
    if (!noteEl) return;

    if (result.reason === 'excluded') {
      noteEl.textContent = 'EMS shipping is not available to this destination.';
    } else if (result.reason === 'over_weight') {
      noteEl.textContent =
        'Weight exceeds the estimate table. Shipping will be calculated at checkout.';
    } else {
      noteEl.textContent =
        'Shipping estimate is unavailable for this country. See International Buyers Guide or checkout.';
    }
  }

  function bind(root) {
    if (!root || root.dataset.emsBound === 'true') return;
    root.dataset.emsBound = 'true';

    var select = root.querySelector('[data-ems-country]');
    if (select) {
      restoreCountry(select, root);
      bindCountryUi(root);
      select.addEventListener('change', function () {
        try {
          sessionStorage.setItem(STORAGE_KEY, select.value);
        } catch (e) {}
        render(root);
      });
    }

    render(root);
  }

  function initAll() {
    document.querySelectorAll('[data-ems-estimator]').forEach(bind);
  }

  function rebindAll() {
    document.querySelectorAll('[data-ems-estimator]').forEach(function (root) {
      root.dataset.emsBound = 'false';
      var ui = root.querySelector('[data-ems-country-ui]');
      if (ui) ui.dataset.emsCountryUiBound = 'false';
      bind(root);
    });
  }

  function renderAll() {
    document.querySelectorAll('[data-ems-estimator]').forEach(render);
  }

  function wireDynamicUpdates() {
    document.addEventListener('change', function (event) {
      var t = event.target;
      if (!t) return;
      if (t.matches('[name="id"], [name="quantity"], .quantity__input, variant-selects, variant-radios')) {
        renderAll();
      }
      if (t.closest && (t.closest('variant-selects') || t.closest('variant-radios'))) {
        renderAll();
      }
    });

    document.addEventListener('input', function (event) {
      var t = event.target;
      if (t && t.matches('[name="quantity"], .quantity__input')) {
        renderAll();
      }
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        requestAnimationFrame(rebindAll);
      });
      if (PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, function () {
          renderAll();
        });
      }
    }
  }

  // Guide page stays English (excluded from GTranslate); fees only use local currency.
  var GUIDE_ZONE_TITLES = {
    zone1: '🇨🇳 🇰🇷 🇹🇼 Asia (China, S.Korea, Taiwan)',
    zone2: '🌏 Other Asia Countries',
    zone3: '🇪🇺 🇬🇧 🇨🇦 Europe, UK, Canada, Oceania',
    zone4: '🇺🇸 USA',
    zone5: '🌍 Central/South America, Africa',
  };

  var GUIDE_ZONE_SUBS = {
    zone1: '(Zone 1)',
    zone2: '(Zone 2)',
    zone3: '(Zone 3)',
    zone4: '(Zone 4 Courier / DHL)',
    zone5: '(Zone 5)',
  };

  var GUIDE_ZONE_NOTES = {
    zone1: 'Fast neighborhood shipping.',
    zone2: 'Calculated dynamically.',
    zone3: 'Shipping cost per item drops significantly with multiple items.',
    zone4: '✨ Flat rate up to 5 items! Buy more, save on shipping.',
    zone5: 'Varies depending on location.',
  };

  var GUIDE_ZONE_ORDER = ['zone4', 'zone3', 'zone1', 'zone2', 'zone5'];

  var GUIDE_RECORD_WEIGHTS = [500, 800, 1000, 1250, 1500];

  function guideZoneTitle(zone) {
    if (!zone) return '';
    return GUIDE_ZONE_TITLES[zone.zone_id] || zone.zone_name || zone.zone_id;
  }

  function fillGuideTablePrices(root, data) {
    if (!root || !data) return;
    var currency = getCurrency();
    var codeEl = root.querySelector('[data-ems-currency-code]');
    if (codeEl) {
      codeEl.textContent = currency.code;
      codeEl.classList.add('notranslate');
      codeEl.setAttribute('translate', 'no');
    }

    var zoneMap = {};
    (data.zones || []).forEach(function (zone) {
      zoneMap[zone.zone_id] = zone;
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-ems-zone]'), function (zoneEl) {
      var zone = zoneMap[zoneEl.getAttribute('data-ems-zone')];
      if (!zone) return;
      Array.prototype.forEach.call(zoneEl.querySelectorAll('[data-ems-row-weight]'), function (cell) {
        var weight = Number(cell.getAttribute('data-ems-row-weight'));
        var priceEl = cell.hasAttribute('data-ems-row-price')
          ? cell
          : cell.querySelector('[data-ems-row-price]');
        if (!priceEl) return;
        var price = findPriceJpy(zone, weight);
        if (price == null) return;
        priceEl.textContent = formatMoney(price, currency);
        priceEl.classList.add('notranslate');
        priceEl.setAttribute('translate', 'no');
      });
    });

    var usa = zoneMap.zone4;
    if (usa) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-ems-usa-extra]'), function (el) {
        var weight = Number(el.getAttribute('data-ems-usa-extra'));
        var price = findPriceJpy(usa, weight);
        if (price == null) return;
        el.textContent = formatMoney(price, currency);
        el.classList.add('notranslate');
        el.setAttribute('translate', 'no');
      });
    }
  }

  function buildGuideTable(data, currency) {
    var wrap = document.createElement('div');
    wrap.className = 'ap-ems-rates-table notranslate';
    wrap.setAttribute('data-ems-rates-table', 'true');
    wrap.setAttribute('translate', 'no');
    wrap.setAttribute('lang', 'en');

    var heading = document.createElement('h3');
    heading.className = 'ap-ems-rates-table__heading';
    heading.textContent = 'Estimated Shipping Fees Reference (EMS / Courier)';
    wrap.appendChild(heading);

    var intro = document.createElement('p');
    intro.className = 'ap-ems-rates-table__intro';
    intro.innerHTML =
      "All records are shipped via Japan Post's EMS service (Express Mail Service with tracking and full insurance, 7–14 days). " +
      'For the United States, we ship using Courier services. Amounts below are converted to your selected store currency (' +
      '<span data-ems-currency-code">' +
      currency.code +
      '</span>' +
      '). Final shipping is calculated at checkout. Duties/taxes may apply.';
    wrap.appendChild(intro);

    var scroll = document.createElement('div');
    scroll.className = 'ap-ems-rates-table__scroll';
    var table = document.createElement('table');
    table.className = 'ap-ems-rates-table__matrix';
    table.innerHTML =
      '<thead><tr>' +
      '<th>Destination / Region</th>' +
      '<th>1 Record</th><th>2 Records</th><th>3 Records</th><th>4 Records</th><th>5 Records</th>' +
      '<th>Special Note / Benefit</th>' +
      '</tr></thead>';

    var tbody = document.createElement('tbody');
    var zoneMap = {};
    (data.zones || []).forEach(function (zone) {
      zoneMap[zone.zone_id] = zone;
    });

    GUIDE_ZONE_ORDER.forEach(function (zoneId) {
      var zone = zoneMap[zoneId];
      if (!zone) return;
      var tr = document.createElement('tr');
      tr.className =
        'ap-ems-rates-table__row' + (zoneId === 'zone4' ? ' ap-ems-rates-table__row--usa' : '');
      tr.setAttribute('data-ems-zone', zoneId);

      var dest = document.createElement('td');
      dest.className = 'ap-ems-rates-table__dest';
      dest.innerHTML =
        '<span class="ap-ems-rates-table__dest-title">' +
        guideZoneTitle(zone) +
        '</span><span class="ap-ems-rates-table__dest-sub">' +
        (GUIDE_ZONE_SUBS[zoneId] || '') +
        '</span>';
      tr.appendChild(dest);

      GUIDE_RECORD_WEIGHTS.forEach(function (weight) {
        var td = document.createElement('td');
        td.setAttribute('data-ems-row-weight', String(weight));
        td.setAttribute('data-ems-row-price', '');
        var price = findPriceJpy(zone, weight);
        td.textContent = price == null ? '—' : formatMoney(price, currency);
        td.classList.add('notranslate');
        td.setAttribute('translate', 'no');
        tr.appendChild(td);
      });

      var note = document.createElement('td');
      note.className = 'ap-ems-rates-table__note';
      note.textContent = GUIDE_ZONE_NOTES[zoneId] || '';
      tr.appendChild(note);
      tbody.appendChild(tr);
    });

    table.appendChild(tbody);
    scroll.appendChild(table);
    wrap.appendChild(scroll);

    var usa = zoneMap.zone4;
    var extra = document.createElement('p');
    extra.className = 'ap-ems-rates-table__usa-extra';
    extra.innerHTML =
      '<strong>For USA (Over 5 items):</strong> 6–7 records: <span class="notranslate" data-ems-usa-extra="1750">' +
      (usa && findPriceJpy(usa, 1750) != null ? formatMoney(findPriceJpy(usa, 1750), currency) : '—') +
      '</span> / 8–9 records: <span class="notranslate" data-ems-usa-extra="2500">' +
      (usa && findPriceJpy(usa, 2500) != null ? formatMoney(findPriceJpy(usa, 2500), currency) : '—') +
      '</span> / 10–11 records: <span class="notranslate" data-ems-usa-extra="3000">' +
      (usa && findPriceJpy(usa, 3000) != null ? formatMoney(findPriceJpy(usa, 3000), currency) : '—') +
      '</span>.';
    wrap.appendChild(extra);

    var weightNote = document.createElement('p');
    weightNote.className = 'ap-ems-rates-table__weight-note';
    weightNote.innerHTML =
      '<strong>How weight is determined internally:</strong> Each single 12" is counted as 250g. A double-vinyl is 500g. The specialized mailer box adds 250g. At checkout, the price is converted to your local currency automatically.';
    wrap.appendChild(weightNote);

    return wrap;
  }

  function removeLegacyGuideRates() {
    if (window.__apEmsGuideReplaced) return;
    var containers = document.querySelectorAll('.ap-foreign-visitor-block, .rte, .shopify-section');
    var target = null;

    for (var i = 0; i < containers.length; i++) {
      var text = containers[i].textContent || '';
      if (text.indexOf('[Zone 1:') !== -1 || text.indexOf('1 record: ¥') !== -1) {
        target = containers[i];
        break;
      }
    }
    if (!target) return;

    var html = target.innerHTML;
    var zonePattern =
      /(?:<p[^>]*>[\s\S]*?For your reference[\s\S]*?<\/p>\s*)?(?:<p[^>]*>[\s\S]*?\[Zone 1:[\s\S]*?\[Zone 5:[\s\S]*?<\/p>)/i;
    if (zonePattern.test(html)) {
      target.innerHTML = html.replace(zonePattern, '');
      window.__apEmsGuideReplaced = true;
      return;
    }

    var paragraphs = Array.prototype.slice.call(target.querySelectorAll('p'));
    var startIndex = -1;
    var endIndex = -1;
    for (var p = 0; p < paragraphs.length; p++) {
      var pText = paragraphs[p].textContent || '';
      if (startIndex === -1 && (pText.indexOf('[Zone 1:') !== -1 || pText.indexOf('For your reference') !== -1)) {
        startIndex = p;
      }
      if (startIndex !== -1 && /\[Zone 5:/.test(pText)) {
        endIndex = p;
        break;
      }
    }
    if (startIndex === -1) return;
    if (endIndex === -1) endIndex = startIndex;
    for (var j = startIndex; j <= endIndex; j++) {
      if (paragraphs[j] && paragraphs[j].parentNode) {
        paragraphs[j].parentNode.removeChild(paragraphs[j]);
      }
    }
    window.__apEmsGuideReplaced = true;
  }

  function refreshGTranslate() {
    try {
      // Ask GTranslate to reconsider newly present Japanese source nodes.
      document.dispatchEvent(new Event('gt-translate-force', { bubbles: true }));
      var html = document.documentElement;
      if (html) {
        html.classList.add('ap-ems-gt-ping');
        setTimeout(function () {
          html.classList.remove('ap-ems-gt-ping');
        }, 0);
      }
    } catch (e) {}
  }

  function initGuideRatesFromBoots() {
    if (window.__apEmsGuideBooted) return;

    var tables = document.querySelectorAll('[data-ems-rates-table]');
    var ratesEl =
      document.querySelector('[data-ems-rates-table] [data-ems-rates]') ||
      document.querySelector('[data-ems-guide-boot] [data-ems-rates]') ||
      document.querySelector('[data-ems-rates]');
    if (!ratesEl) return;

    var data = normalizeRatesData(readJson(ratesEl));
    if (!data) return;
    window.__apEmsGuideBooted = true;

    var currency = getCurrency();

    if (tables.length) {
      Array.prototype.forEach.call(tables, function (table) {
        fillGuideTablePrices(table, data);
      });
    } else {
      // Fallback: inject Japanese table when SSR markup is missing
      var built = buildGuideTable(data, currency);
      var host =
        document.querySelector('.ap-foreign-visitor-block') ||
        document.querySelector('.ap-foreign-visitor .page-width');
      if (host) host.appendChild(built);
    }

    removeLegacyGuideRates();
    refreshGTranslate();
  }

  window.ApEmsEstimator = {
    initAll: initAll,
    rebindAll: rebindAll,
    render: render,
    estimate: estimate,
    formatMoney: formatMoney,
    getCurrency: getCurrency,
    initGuideRatesFromBoots: initGuideRatesFromBoots,
    sanitizeWeightGrams: sanitizeWeightGrams,
  };

  function boot() {
    initAll();
    wireDynamicUpdates();
    initGuideRatesFromBoots();
    // GTranslate等で後からDOMが触られる場合に再試行
    setTimeout(function () {
      window.__apEmsGuideBooted = false;
      initGuideRatesFromBoots();
    }, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
